import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_company/_legacy/my_campaigns/$companyId")({
  params: {
    parse: raw => ({companyId: +raw.companyId}),
    stringify: params => ({companyId: params.companyId?.toString()}),
  },
  beforeLoad: ({params, search}) => {
    throw redirect({to: "/company/$companyId/dashboard", params: {companyId: params.companyId}, search, replace: true});
  },
});
